import { Input, Modal } from 'antd'
import { useTranslation } from 'react-i18next'

/** Generic "重命名图片/分组" dialog, extracted out of `Home.tsx` so the SaaS
 * Workspace Images page's "改名" reuses the exact same interaction (single
 * input, Enter-to-confirm) instead of a bespoke SaaS-only rename UI. */
export default function RenameModal({
  open,
  title,
  value,
  onChange,
  onOk,
  onCancel,
}: {
  open: boolean
  title: string
  value: string
  onChange: (v: string) => void
  onOk: () => void
  onCancel: () => void
}) {
  const { t: tActions } = useTranslation('actions')

  return (
    <Modal
      title={title}
      open={open}
      onOk={onOk}
      onCancel={onCancel}
      okText={tActions('confirm')}
      cancelText={tActions('cancel')}
      destroyOnClose
    >
      <Input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onPressEnter={onOk}
        autoFocus
        data-testid="rename-input"
      />
    </Modal>
  )
}
